const date = new Date()
const dateNow = date.getFullYear()

const dateTarget = document.querySelector('.footer__year span');

dateTarget.innerHTML = dateNow
